import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How do you come up with your cash offer?",
    a: "We look at recent comparable sales in your neighborhood, the current condition of your home, and the cost of any repairs needed. A real analyst — not an algorithm — reviews every offer. We'll explain each number so you can compare honestly against listing with an agent.",
  },
  {
    q: "Will I have to pay any fees or commissions?",
    a: "No. There are no commissions, no listing fees, and we pay standard closing costs. The price we offer is the money you walk away with at closing.",
  },
  {
    q: "What kinds of properties do you buy?",
    a: "Single-family homes, townhouses, duplexes, mobile homes on land, and inherited properties — in any condition. Move-in ready, needs-repair, fire damage, tenant-occupied, behind on payments. If it's in Eastern NC, we're interested.",
  },
  {
    q: "How fast can you actually close?",
    a: "As fast as 7 days when title is clean. Most sellers choose a 14–30 day window so they can coordinate a move. You pick the date — we work around your schedule.",
  },
  {
    q: "I'm behind on payments. Can you still help?",
    a: "Yes — this is one of the most common situations we help with. We work directly with your lender to stop the foreclosure clock and close before it damages your credit further. Call us the moment you get a notice and we'll walk you through options.",
  },
  {
    q: "Do I have to accept the offer?",
    a: "Never. Getting an offer is 100% free with zero obligation. Many sellers use our offer as a benchmark while they shop around. No pressure, no calls after you say no.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-b border-[var(--c4p-line)] bg-[var(--c4p-ivory)] py-20 lg:py-28"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10">
        <div className="lg:col-span-4">
          <span className="eyebrow">Questions, answered.</span>
          <h2 className="font-display mt-4 text-[40px] leading-[1.02] sm:text-[52px] lg:text-[60px]">
            Straight{" "}
            <span className="font-display-italic text-[var(--c4p-orange)]">answers.</span>
          </h2>
          <p className="mt-6 max-w-sm font-sans-ui text-[15px] leading-relaxed text-[var(--c4p-muted)]">
            Still unsure? Call Triston directly at{" "}
            <a
              href="tel:+19102125006"
              className="font-semibold underline decoration-[var(--c4p-orange)] underline-offset-4"
            >
              (910) 212-5006
            </a>
            . Real person, no voicemail loop.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion
            type="single"
            collapsible
            defaultValue="item-0"
            data-testid="faq-accordion"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="faq-item border-0"
              >
                <AccordionTrigger
                  data-testid={`faq-q-${i}`}
                  className="font-sans-ui text-left text-[17px] font-semibold leading-snug text-[var(--c4p-ink)] hover:no-underline sm:text-[18px]"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-a-${i}`}
                  className="font-sans-ui text-[14.5px] leading-relaxed text-[var(--c4p-muted)]"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
